import {axios} from '@js/utilities/axios.js';
export default {
	namespaced: true,
	state: {
		selected_candidate: {},
		show_profile: false,
		lock: {}
	},
	actions: {
		setCandidate (context, id) {
			context.state.selected_candidate = {};
			return new Promise((resolve, reject) => {
				axios.get('/api/candidates/' + id).then((response) => {
					context.commit('setSelectedCandidate', response.data.data);
					resolve(response);
				}).catch((error) => {
					alert('Something went wrong.');
					reject(error);
				});
			});
		},
		lock (context) {
			return new Promise((resolve, reject) => {
				axios.post(`/api/candidates/${context.state.selected_candidate.id}/lock`).then(response => {
					context.commit('setLock', response.data);
					resolve(response);
				}).catch(error => {
					reject(error);
				});
			})
		},
		unlock (context) {
			return new Promise((resolve, reject) => {
				axios.post(`/api/candidates/${context.state.selected_candidate.id}/unlock`).then(response => {
					context.commit('setLock', {});
					resolve(response);
				}).catch(error => {
					reject(error);
				});
			})
		},
		refresh (context) {
			return new Promise((resolve, reject) => {
				axios.get('/api/candidates/' + context.state.selected_candidate.id).then((response) => {
					context.commit('setSelectedCandidate', response.data.data);
					resolve(response);
				}).catch((error) => {
					alert('Something went wrong.');
					reject(error);
				});
			})
		},
		fetchCandidate(context, id) {
			return new Promise((resolve, reject) => {
				axios.get('/api/candidates/' + id).then((response) => {
					context.commit('setSelectedCandidate', response.data.data);
					resolve(response);
				}).catch((error) => {
					alert('Something went wrong.');
					reject(error);
				});
			});
		},
		updateCandidate(context) {
			let candidate = {...context.state.selected_candidate}
			return axios.put(`/api/candidates/edit/${candidate.id}`, candidate);
		},
	},
	mutations: {
		setSelectedCandidate (state, candidate) {
			state.selected_candidate = candidate;
		},
		setLock (state, lock) {
			state.lock = lock;
		}
	},
	getters: {
		getSelectedCandidate(state) {
			return state.selected_candidate;
		},
		getLock(state) {
			return state.lock;
		},
		daysAvailable(state) {
			if (state.selected_candidate.days_available && state.selected_candidate.days_available.length) {
				return state.selected_candidate.days_available.join(',');
			} else {
				return '';
			}
		}
	}
}
